export enum ServiceStatus {
	INACTIVE = "inactive",
	ACTIVE = "active",
	PENDING_APPROVAL = "pending_approval"
}
